import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component, Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import {faFacebook} from '@fortawesome/free-brands-svg-icons'
import {faYoutube} from '@fortawesome/free-brands-svg-icons'
import {faInstagram} from '@fortawesome/free-brands-svg-icons'

import {faPhone} from '@fortawesome/free-solid-svg-icons'

import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faLocation } from '@fortawesome/free-solid-svg-icons'

export class Footer extends Component {
  render() {
    return (
           <Fragment>
            <Container fluid={true} className='footerSection containerS'>
             
                <Row>
                    <Col lg={3} md={6} sm={12} className='p-5 text-center'>
                    <h2 className='footerName text-center'> Follow Us</h2>
                    <div className='socialContainer'>
                    <a href='' className='social socialColor'>
                    <FontAwesomeIcon icon={faFacebook} size="2x" ></FontAwesomeIcon>
                       </a > 
                        <a href='' className='social socialColor'>
                              <FontAwesomeIcon icon={faYoutube} size="2x" ></FontAwesomeIcon>
                        </a>
                            <a href='' className='social socialColor'>
                                  <FontAwesomeIcon icon={faInstagram} size="2x" ></FontAwesomeIcon>
                            </a>
                            </div>
                    </Col>
                     <Col lg={3} md={6} sm={12} className='p-5 text-justify'>
                      <h2 className='footerName text-center'> Address</h2>
                      <p className='footerdescription'> <FontAwesomeIcon icon={faLocation}  ></FontAwesomeIcon>  37 Pharmacy Ave, M1K 1B9
                       <br></br>   <FontAwesomeIcon icon={faEnvelope} ></FontAwesomeIcon>  Email: Supportbd@gmail.Com
                       <br />   <FontAwesomeIcon icon={faPhone}  ></FontAwesomeIcon>  Phone: 4379980490
                      </p>

                    </Col>
                     <Col lg={3} md={6} sm={12} className='p-5 text-center'>
                      <h2 className='footerName text-center'>  Information</h2>
                      <a className='footerLink' href="">About Me</a> <br></br>
                      <a  className='footerLink' href=''>Company Profile</a><br />
                      <a className='footerLink' href=''>Contact Us</a>
                    </Col>
                     <Col lg={3} md={6} sm={12} className='p-5 text-center'>
                      <h2 className='footerName text-center'> Policy</h2>
                       <a className='footerLink' href="">Refund Policy</a> <br></br>
                      <a className='footerLink' href=''>Terms & Condition</a><br />
                      <a className='footerLink' href=''>Privacy Policy</a>
                    </Col>
                </Row>
            </Container>
            <Container fluid="true" className='text-center copyRight'>
              <a className='copyrightL' href=''> @ Copyright 2025 by NovoEvents, All Rights Reserved</a>

            </Container>

            </Fragment>
    )
  }
}

export default Footer
